import axios from "axios";

export default axios.create({
  baseURL: "https://chitter-backend-api-v2.herokuapp.com"
});






